import styled from 'styled-components';
import { palette } from 'styled-tools';

import {
	Button,
	ButtonSizes,
	FontSizes,
	FontWeights,
	Text,
	TextAlign,
	TextButton,
} from '@calm-web/design-system';
import { PlayFilled } from '@calm-web/icons';

export const Wrapper = styled.li`
	align-items: center;
	cursor: pointer;
	display: flex;
	opacity: 1;
	padding: 16px 0 24px;
	text-align: left;
	z-index: 0;
`;

export const ClickableWrapper = styled(TextButton).attrs({
	textColor: 'white',
})`
	text-align: left;
	text-decoration: none;
	flex: 1;
	padding-right: 16px;
`;

export const Title = styled(Text).attrs((p: { $isPlaying: boolean }) => ({
	size: FontSizes.base,
	align: TextAlign.Left,
	el: 'div',
	color: p.$isPlaying ? 'gold' : 'white',
	weight: FontWeights.Demi,
}))<{
	$isPlaying: boolean;
}>``;

export const Subtitle = styled.div`
	color: ${palette('white')};
	font-weight: 400;
	margin-bottom: 8px;
	text-align: left;
	width: 100%;
`;

export const Duration = styled.div`
	font-size: 13.5px;
	font-weight: 700;
`;

export const PlayIcon = styled(Button).attrs({
	Icon: PlayFilled,
	backgroundColor: 'whiteAlpha10',
	size: ButtonSizes.Sm,
})``;
